module.exports = ".result-button {\n    padding: 7px 15px 7px 15px;\n}\n.reportsTab .list-group-item:nth-child(2n+1) {\n    background-color: rgba(0, 0, 0, 0.05);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/client-edit/client-edit.component.css
// module id = ./src/app/admin/client-edit/client-edit.component.css
// module chunks = main